export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stare hasło"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nowe hasło"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potwierdzenie hasła"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zapisz"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["\"Nowe hasło\" i \"Potwierdzenie hasła\" nie pasują do siebie."])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zmiana hasła"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Od 4 do 63 znaków. Dozwolone są litery alfabetu łacińskiego, cyfry i symbole"])},
  "strength": {
    "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Puste"])},
    "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Słabe"])},
    "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Średnie"])},
    "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Silne"])}
  }
}